export default __webpack_public_path__ + "4292a83d8d7afe266ab2a11f2ba45705.png";